// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"76345229","215":"c9996395","236":"423ee303","317":"1e1ea9c9","423":"8aff4b14","726":"1822b69c","745":"fba46430","893":"328b1157","924":"d2b5a29b"}[chunkId] + ".chunk.css";
};